import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config/axios"
import Modal from "react-bootstrap/Modal";
import { formatDate, formattedDate } from "../../Date";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast } from "../../CustomFunctions";
import { AddwithBlueCircle, DropdownArrow } from "../../AllSvg";

const RequisitionAddmodel = ({ getOnboarding, departmentname, designationname }) => {

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getCompanyDetails(sessionStorage.getItem("rh"))
        setShow(true)
    };

    const [empCode, setEmpCode] = useState()
    const getCompanyDetails = async (email) => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemail/${email}/`);
            setEmpCode(res.data.emp_code)
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    const [formData, setFormData] = useState({

        empcode: sessionStorage.getItem("emp_code"),
        name: sessionStorage.getItem("name"),
        rh_assigned: empCode,
        department: "",
        date: formattedDate,
        designation: "",

    });



    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "department",
            "designation",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };



    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                ...formData,
                empcode: sessionStorage.getItem("emp_code"),
                name: sessionStorage.getItem("name"),
                sub_company: sessionStorage.getItem('company_id'),
                rh_assigned: empCode,
            };

            try {

                let res = await axios.post(`${BASE_URL}/jd/requisition/`, updatedFormData,)

                if (res.status === 200) {
                    handleClose()
                    await getOnboarding()
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>

            <button className="models-button model-add" title="Add Requisition Request" onClick={handleShow} style={{ margin: "2px" }}>
                <AddwithBlueCircle />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>New Requisition Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <form className="register-form">
                            <div className="form-flex-wrap">
                                <div className="flex-row form-group-selectt">
                                    <label htmlFor="department" className="form-labels  font-weight500    font-size-subheading">
                                        Department<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="department"
                                        name="department"
                                        value={formData.department}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.department ? "error" : inputState.department ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Department</option>
                                        {departmentname?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                            <option value={i.id}>{i.title}</option>
                                        </>))
                                        }
                                    </select>
                                    <DropdownArrow />
                                    <div>
                                        {errors.department && (
                                            <span className="error-message font-size-text ">{errors.department}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-row form-group-selectt">
                                    <label htmlFor="designation" className="form-labels  font-weight500    font-size-subheading">
                                        Designation<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="designation"
                                        name="designation"
                                        value={formData.designation}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.designation ? "error" : inputState.designation ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Designation</option>
                                        {designationname?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                            <option value={i.id}>{i.title}</option>
                                        </>))
                                        }
                                    </select>
                                    <DropdownArrow />
                                    <div>
                                        {errors.designation && (
                                            <span className="error-message font-size-text ">{errors.designation}</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="button-models">
                                <button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit" disabled={loading} >{/* //loading logic */}
                                    Submit
                                </button>
                            </div>
                        </form></>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>
            </Modal>

        </>
    );
};

export default RequisitionAddmodel;
